document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".contact-form form");

  if (form) {
    const requiredCheckboxes = form.querySelectorAll(
      'input[type="checkbox"][required]'
    );

    requiredCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const name = this.name;
        const group = form.querySelectorAll(`input[name="${name}"]`);
        const isAnyChecked = Array.from(group).some((cb) => cb.checked);

        group.forEach((cb) => {
          if (isAnyChecked) {
            cb.removeAttribute("required");
          } else {
            cb.setAttribute("required", "");
          }
        });
      });
    });
  }
});
